const HurricaneDataLayer = {
	FORECAST_POSITION: "Forecast Position",
	FORECAST_ERRORCONE: "Forecast Error Cone",
	HISTORIC_POSITION: "Historic Position",
	FORCE_34KNOTS: "Force - 34 knots+",
	FORCE_50KNOTS: "Force - 50 knots+",
	FORCE_64PLUSKNOTS: "Force - 64 knots+"
};
export default HurricaneDataLayer;
